import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "ad-Foot" }
const _hoisted_2 = { class: "ad-Foot-list" }
const _hoisted_3 = { class: "ad-Foot-item toggle-menu" }
const _hoisted_4 = { class: "ad-Foot-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Control = _resolveComponent("Control")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _createVNode(_component_font_awesome_icon, {
          icon: !_ctx.isHidden ? 'minus' : 'plus',
          onClick: _ctx.toggleFooter
        }, null, 8, ["icon", "onClick"]),
        (!_ctx.isHidden)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleFooter && _ctx.toggleFooter(...args)))
            }, " Hide Menu"))
          : _createCommentVNode("", true),
        (_ctx.isHidden)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleFooter && _ctx.toggleFooter(...args)))
            }, " Show Menu"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("li", {
        class: _normalizeClass(["ad-Foot-item pb-2", { hidden: _ctx.isHidden }])
      }, [
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "ad-Controls-label" }, "Select a style to apply to all lines: ", -1)),
        _createVNode(_component_Control, {
          name: "",
          type: "choices",
          id: "pointType",
          checked: _ctx.isLineCurved,
          choices: [
            {
              name: 'Straight Lines',
              value: 'l',
              checked: !_ctx.isLineCurved,
            },
            { name: 'Curved Lines', value: 'c', checked: _ctx.isLineCurved },
          ],
          onOnChange: _cache[2] || (_cache[2] = (e) => _ctx.setPointType(e))
        }, null, 8, ["checked", "choices"])
      ], 2),
      _createElementVNode("li", {
        class: _normalizeClass(["ad-Foot-item", { hidden: _ctx.isHidden }])
      }, [...(_cache[4] || (_cache[4] = [
        _createElementVNode("span", { class: "ad-Foot-highlight" }, "Click and Drag", -1),
        _createTextVNode(" a hotspot to reposition ", -1)
      ]))], 2),
      _createElementVNode("li", {
        class: _normalizeClass(["ad-Foot-item", { hidden: _ctx.isHidden }])
      }, [...(_cache[5] || (_cache[5] = [
        _createElementVNode("span", { class: "ad-Foot-highlight" }, "Double Click", -1),
        _createTextVNode(" a hotspot to edit contents ", -1)
      ]))], 2),
      _createElementVNode("li", {
        class: _normalizeClass(["ad-Foot-item", { hidden: _ctx.isHidden }])
      }, [...(_cache[6] || (_cache[6] = [
        _createElementVNode("span", { class: "ad-Foot-highlight" }, "ALT + Click ", -1),
        _createTextVNode(" to add a hotspot ", -1)
      ]))], 2),
      _createElementVNode("li", _hoisted_4, [
        _createVNode(_component_Button, {
          text: "Save Track",
          onClick: _ctx.save,
          class: "w-100 mt-2",
          disabled: !_ctx.trackIsDirty
        }, null, 8, ["onClick", "disabled"])
      ])
    ])
  ]))
}